__turbopack_context__.v({
  "h2Caption": "_5rEH3q_h2Caption",
  "h2LG": "_5rEH3q_h2LG",
  "iPlayfair": "_5rEH3q_iPlayfair",
  "linkButton": "_5rEH3q_linkButton",
  "main": "_5rEH3q_main",
  "underlineBtn": "_5rEH3q_underlineBtn",
  "underlineBtnAfter": "_5rEH3q_underlineBtnAfter",
  "underlineBtnBefore": "_5rEH3q_underlineBtnBefore",
});
